function Research2024() {

    return (
      <>
        <div className="ml-10 mt-5">
          <div className="flex">
            <div className="w-16">2024</div>

            <div className="w-full">
            <div className="flex">
                    <div className="w-16">Dec</div>
                    <div className="w-full">
                        <p><a href="http://events.kias.re.kr/h/MathAlumni24/" target='_blank'>“On a subquotient construction for categories.”</a></p>
                        <p>The 8th KIAS Alumni Workshop in Mathematics, KIAS</p>
                    </div>
                </div>

                <div className="flex mt-2">
                    <div className="w-16">Nov</div>
                    <div className="w-full">
                        <p><a href="https://sites.google.com/view/dgt5" target='_blank'>“A categorified eigenring action on Jacobi diagrams in handlebodies.”</a></p>
                        <p>Dynamical Group Theory V, Gimhae Lotte Hotels & Resorts</p>
                    </div>
                </div>

                <div className="flex mt-2">
                    <div className="w-16">Oct</div>
                    <div className="w-full">
                        <p><a href="https://www.kms.or.kr/conference/2024_fall/" target='_blank'>“A categorified eigen-ring action on Jacobi diagrams in handlebodies.”</a></p>
                        <p>2024 KMS Autumn meeting, Special Session, Sungkyunkwan university</p>
                    </div>
                </div>

                <div className="flex mt-2">
                    <div className="w-16">Jul</div>
                    <div className="w-full">
                        <p><a href="https://sites.google.com/view/2024wat" target='_blank'>“Eigen-ring construction for linear categories.”</a></p>
                        <p>Workshop on Algebra and Topology, Jeonbuk National University</p>
                    </div>
                </div>

                <div className="flex mt-2">
                    <div className="w-16">Jun</div>
                    <div className="w-full">
                        <p><a href="https://www.usc.gal/regaca/ct2024/index.html" target='_blank'>“On eigen-ring construction for monads.”</a></p>
                        <p>International Category Theory Conference CT2024, Poster session, Santiago de Compostela</p>
                    </div>
                </div>

                <div className="flex mt-2">
                    <div className="w-16">May</div>
                    <div className="w-full">
                        <p><a href="https://visgat.cayley.kr/" target='_blank'>“Polynomial ideal and primitivity ideal.”</a></p>
                        <p>VISGAT, KIAS</p>
                    </div>
                </div>

                <div className="flex mt-2">
                    <div className="w-16">May</div>
                    <div className="w-full">
                        <p><a href="https://visgat.cayley.kr/" target='_blank'>“Polynomial functors on free groups.”</a></p>
                        <p>VISGAT, KIAS</p>
                    </div>
                </div>

                <div className="flex mt-2">
                    <div className="w-16">Apr</div>
                    <div className="w-full">
                        <p><a href="https://www.kms.or.kr/conference/2024_spring/" target='_blank'>“Finite path integral and a cohomology class induced by generalized (co)homology theory.”</a></p>
                        <p>2024 KMS Spring meeting, KAIST and Daejeon Convention Center</p>
                    </div>
                </div>

                <div className="flex mt-2">
                    <div className="w-16">Mar</div>
                    <div className="w-full">
                        <p><a href="https://www.math.snu.ac.kr/board/index.php?mid=video&category=814901" target='_blank'>“Finite path integral and a second monoidal cohomology class of cobordism category.”</a></p>
                        <p>BK 21 FOUR Rookies Pitch, Seoul National University</p>
                    </div>
                </div>

                <div className="flex mt-2">
                    <div className="w-16">Feb</div>
                    <div className="w-full">
                        <p><a href="https://www.kurims.kyoto-u.ac.jp/~eacgt/" target='_blank'>“Analyticity and primitivity of exponential functors on free groups.”</a></p>
                        <p>The 19th East Asian Conference on Geometric Topology, RIMS, Kyoto University</p>
                    </div>
                </div>
                
                <div className="flex mt-2">
                    <div className="w-16">Jan</div>
                    <div className="w-full">
                        <p><a href="https://sites.google.com/view/kaistgtfair2024/home" target='_blank'>“On analytic exponential functors on free groups”</a></p>
                        <p>KAIST Geometry and Topology Fair, Busan</p>
                    </div>
                </div>

            </div>
          </div>
        </div>
      </>
    );
  }
  
  export default Research2024;